import styled, { themeGet, css, device } from "@doar/shared/styled";

export const HostingLogo = styled(({ ...rest }) => <img {...rest} />)`
  height: 16px;
  width: 16px;
  object-fit: contain;
`;